import Vue from 'vue';

export default {
  async get() {
    return (await Vue.http.get('/api/users')).data;
  },
  async login(model) {
    return (await Vue.http.post('/api/users/login', model)).data;
  },
  async logout() {
    return (await Vue.http.get('/api/users/logout')).data;
  }
}



// WEBPACK FOOTER //
// ./src/services/user.service.js